// extracted by mini-css-extract-plugin
export default {"wrapper":"EmojiModal_wrapper__MU36j","back":"EmojiModal_back__-jUUg","show":"EmojiModal_show__3qRBi"};